import React from 'react';

import ButtonDropdown from 'components/ButtonDropdown';
import PaginatorComponent from 'components/Paginator';

import './styles.css';

const Actions = ({
  exportBookingSetsCsvInBackground,
  exportingBookingSetsCsv,
  disableExporting
}) => (
  <ButtonDropdown
    small
    title="Export Options"
    className="exportOptionsButton"
    menuPosition={ButtonDropdown.MENU_POSITION_TOP_RIGHT}
    isLoading={exportingBookingSetsCsv}
    disabled={disableExporting}
    tooltip={disableExporting && 'No booking sets to export'}>
    <ButtonDropdown.Option
      onClick={exportBookingSetsCsvInBackground}
      disabled={exportingBookingSetsCsv}>
      Background booking sets CSV export
    </ButtonDropdown.Option>
  </ButtonDropdown>
);

class Paginator extends React.Component<any> {
  render() {
    const {
      exportBookingSetsCsvInBackground,
      exportingBookingSetsCsv,
      disableExporting
    } = this.props;

    return (
      <PaginatorComponent
        pagination={this.props.pagination}
        onPageChange={this.props.onPageChange}
        ActionsComponent={() => (
          <Actions
            exportBookingSetsCsvInBackground={exportBookingSetsCsvInBackground}
            exportingBookingSetsCsv={exportingBookingSetsCsv}
            disableExporting={disableExporting}
          />
        )}
      />
    );
  }
}
export default Paginator;
